import React, { memo } from "react";
import SelectDropdown, {
  SelectDropdownProps,
} from "react-native-select-dropdown";
import { Frame, IsMobile } from "../theme";
import { Ionicons } from "@expo/vector-icons";
import { StyleSheet, Text, View } from "react-native";
import { AppTheme, useTheme } from "../theme/colors";
import {WEB_MAXWIDTH} from "../../constants";

type Props = {
  label?: string;
  simple?: boolean;
  error?: boolean;
} & SelectDropdownProps;

const Dropdown = memo<Props>(({ label, error, simple, ...props }) => {
  const theme = useTheme();
  const style = getStyle(theme, error!);

  return (
    <View
      style={[
        IsMobile
          ? [simple && style.simpleContainer]
          : [simple && style.desktopSimpleContainer],
      ]}
    >
      <Text style={[simple ? style.simpleLabel : style.label]}>{label}</Text>
      <SelectDropdown
        {...props}
        buttonStyle={!simple ? style.dropdown : style.simple}
        rowStyle={[
          {
            paddingVertical: 7,
          },
        ]}
        rowTextStyle={{
          color: theme.TEXT,
        }}
        dropdownStyle={{
          backgroundColor: theme.DARK_GREY,
        }}
        buttonTextStyle={{
          color: theme.TEXT,
        }}
        renderDropdownIcon={() => (
          <Ionicons name="chevron-down" size={20} color={theme.LIGHT_GREY} />
        )}
      />
    </View>
  );
});

export default Dropdown;

const getStyle = (theme: AppTheme, error: boolean) =>
  StyleSheet.create({
    dropdown: {
      width: Frame.width / 1.15,
      backgroundColor: "transparent",
      borderBottomWidth: 1,
      borderBottomColor: theme.LIGHT_GREY,
      marginBottom: 20,
    },
    simple: {
      width: "100%",
      backgroundColor: theme.BACKGROUND,
      height: 20,
    },
    label: {
      color: error ? "red" : theme.TEXT,
      fontSize: 15,
      fontWeight: "bold",
    },
    simpleLabel: {
      fontSize: 11,
      position: "absolute",
      color: error ? "red" : theme.TEXT,
      top: -9,
      left: 10,
      backgroundColor: theme.BACKGROUND,
      padding: 3,
    },
    desktopSimpleContainer: {
      backgroundColor: theme.BACKGROUND,
      position: "relative",
      width: WEB_MAXWIDTH -35,
      borderWidth: 1,
      borderColor: error ? "red" : theme.PRIMARY,
      borderRadius: 6,
      marginLeft: -10,
      padding: 12,
    },

    simpleContainer: {
      backgroundColor: theme.BACKGROUND,
      width: Frame.width / 1.12,
      position: "relative",
      borderWidth: 1,
      borderColor: error ? "red" : theme.PRIMARY,
      borderRadius: 6,
      marginLeft: -10,
      padding: 12,
    },
  });
